import { MiniTableRow, Text } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'

export const CardRow = ({
  label,
  description,
  state,
  updatedAt,
  isLoading,
}: {
  label: string
  description?: string
  state?: React.ReactNode
  updatedAt?: string
  isLoading?: boolean
}) => {
  const { t } = useTranslation()

  return (
    <MiniTableRow
      label={label}
      description={description}
      size={'compact'}
      content={
        <div
          css={theme => ({
            display: 'flex',
            alignItems: 'baseline',
            gap: theme.space.Space3,
            minHeight: 24,
          })}
        >
          {isLoading ? t('common_notApplicable_label') : state}
          <Text size="sm" color="reduced" css={{ minWidth: 50 }}>
            {isLoading
              ? t('common_notApplicable_label')
              : updatedAt
                ? updatedAt
                : t('common_notApplicable_label')}
          </Text>
        </div>
      }
    />
  )
}
